import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_overlay, {
      "model-value": _ctx.isLoading,
      location: "center",
      scrim: "white",
      opacity: _ctx.opacity,
      "z-index": "100"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "l_elmloading" }, [
          _createElementVNode("div", { class: "elmloading" }, [
            _createElementVNode("div", { class: "elmloading_icon" })
          ])
        ], -1)
      ]))]),
      _: 1
    }, 8, ["model-value", "opacity"])
  ]))
}